import { GetExportDataResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';
import { ISupplierForecastExportData, ISupplierForecastExportDataResult } from '../domains/entities/supplierForecastExportData';
import { IYearMonth } from '@/coreDomainsModule/date';
import { SupplierForecastExportDataService } from '../domains/service/supplierForecastExportDataService';
import { convertBase64ToExcelBlob } from '@/appLogic/blobEncoder';

/**
 * 仕入先内示のダウンロード用に取得したデータを適切な形式に変換する
 */
export class SupplierForecastExportDataAdapter {
  /**
   * レスポンス用
   * 仕入先内示のダウンロード用に取得したデータを適切な形式に変換
   * @param response - APIのresponse
   * @param targetStartYearMonth - 対象開始年月
   * @param targetEndYearMonth - 対象終了年月
   */
  public static adaptForResponse = async (
    response: GetExportDataResponseAllOfResult,
    targetStartYearMonth: IYearMonth,
    targetEndYearMonth: IYearMonth
  ): Promise<ISupplierForecastExportDataResult> => {
    // APIから取得したテンプレートデータが存在する場合は、テンプレートデータを設定する
    const blob = await convertBase64ToExcelBlob(response.data.excelFile);

    // 取得したデータが存在しない場合は、空のデータを返す
    const result: ISupplierForecastExportDataResult = {
      supplierForecastTemplateExcelData: blob,
      data: [],
    };

    let currentSubData: ISupplierForecastExportData[] = [];

    // APIから取得したデータに加え、必要箇所に合計行を追加する
    for (const [index, business] of response.data.supplierForecasts.entries()) {
      if (index === 0) {
        result.data.push(business);
        currentSubData.push(business);
        continue;
      }

      // 前のデータと基本データが異なる場合、もしくは最終行の場合は合計行を作成する
      if (!SupplierForecastExportDataService.isSameBaseData(business, response.data[index - 1])) {
        // 一つ前までの合計行を作成する
        result.data.push(
          SupplierForecastExportDataService.createSubTotalSupplierForecastExportData(
            currentSubData,
            targetStartYearMonth,
            targetEndYearMonth
          )
        );
        // 保持配列を初期化
        currentSubData = [];
      }
      // 今回のデータを追加
      result.data.push(business);
      currentSubData.push(business);
    }

    // 最終行の合計行を作成する
    result.data.push(
      SupplierForecastExportDataService.createSubTotalSupplierForecastExportData(currentSubData, targetStartYearMonth, targetEndYearMonth)
    );

    return result;
  };
}
